import axios from 'axios'
import { LOGINAPI_ADDRESS } from 'config'


interface CouncilsAccessListState {
  councilsAccessList: []
  isAcInitalized: false
  isAcLoading: true
  hasAcError: false
}

export const councilsAccessFullList = async (): Promise<CouncilsAccessListState> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  // const url = `${LOGINAPI_ADDRESS}/api/users/councils-access`
  const url = `${LOGINAPI_ADDRESS}/councils-access`
  const { data } = await axios.get(url, config)
  return data
}
